import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Title", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Url Slug", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Start Date", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Summary", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Source Code Url", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "View Url", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Preview Image Url", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Tags (comma separated)", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Description ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("(markdown)")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_UserMessageComponent = _resolveComponent("UserMessageComponent")!
  const _component_PageActionsBarComponent = _resolveComponent("PageActionsBarComponent")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "project-edit-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitleComponent, {
        title: _ctx.isNew ? 'New Project' : 'Edit Project',
        subheading: _ctx.projectReference
      }, null, 8, ["title", "subheading"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingComponent, { message: "Loading Project" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_UserMessageComponent, { details: _ctx.loadUserMessage }, null, 8, ["details"]),
      (!_ctx.isLoading && !_ctx.loadUserMessage.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_PageActionsBarComponent, {
              returnLink: _ctx.returnLink,
              returnText: _ctx.returnText
            }, null, 8, ["returnLink", "returnText"]),
            _createElementVNode("label", null, [
              _hoisted_3,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "My Project",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.titleField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.titleField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "my-project",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.urlSlugField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.urlSlugField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDateField) = $event)),
                min: "2000-01-01",
                max: "2100-01-01"
              }, null, 512), [
                [_vModelText, _ctx.startDateField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_6,
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                placeholder: "Brief description of what the project is",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.summaryField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.summaryField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "https://source.code/my-project",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sourceCodeUrlField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.sourceCodeUrlField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "https://my-project.net",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.viewUrlField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.viewUrlField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "https://images.com/my-project",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.previewImageUrlField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.previewImageUrlField]
              ])
            ]),
            _createElementVNode("label", null, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Java, .Net Core, SQL",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tagsField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.tagsField]
              ])
            ]),
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, [
                _hoisted_11,
                _createVNode(_component_LinkComponent, { href: "https://www.markdownguide.org/basic-syntax/" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _withDirectives(_createElementVNode("textarea", {
                rows: "60",
                placeholder: "Deeper dive into what the project is, why it exists and how it was created. Other thoughts such as struggles and the future of the project.",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.descriptionField) = $event))
              }, null, 512), [
                [_vModelText, _ctx.descriptionField]
              ])
            ]),
            _createElementVNode("label", null, [
              _createVNode(_component_ButtonComponent, { onClick: _ctx.onUpdateProject }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isNew ? 'Create Project' : 'Update Project'), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode(_component_UserMessageComponent, { details: _ctx.submitUserMessage }, null, 8, ["details"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}